import { TagColor } from '@factorialco/deprecated-design-system'
import type { BookkeepersManagementIncidencePayrollIntegrationStatusQuery } from 'generated/resources/graphql'

type BookkeepersManagementIncidencePayrollIntegrationStatus =
  BookkeepersManagementIncidencePayrollIntegrationStatusQuery['bookkeepersManagement']['incidencePayrollIntegrationStatusesConnection']['nodes'][number]

export default function payrollIntegrationStatusTagColor(
  payrollIntegrationIncidenceStatus:
    | BookkeepersManagementIncidencePayrollIntegrationStatus
    | undefined
) {
  if (!payrollIntegrationIncidenceStatus) {
    return TagColor.grey
  }

  const TAG_COLORS: Record<string, TagColor> = {
    unavailable: TagColor.radical,
    available: TagColor.champagne,
    done: TagColor.lime,
  }

  return TAG_COLORS[payrollIntegrationIncidenceStatus.status] || TagColor.grey
}
